export const fmtDate = (iso) => {
  try { return new Date(iso).toLocaleString(); } catch { return iso; }
};

export const fmtSize = (b) => {
  if (!b && b !== 0) return "\u2014";
  if (b < 1024) return `${b} B`;
  if (b < 1024 * 1024) return `${(b / 1024).toFixed(0)} KB`;
  return `${(b / (1024 * 1024)).toFixed(1)} MB`;
};

export const shortType = (mime) => {
  if (!mime) return "\u2014";
  if (mime.includes("pdf")) return "PDF";
  if (mime.includes("png")) return "PNG";
  if (mime.includes("jpeg") || mime.includes("jpg")) return "JPG";
  if (mime.includes("word") || mime.includes("msword")) return "DOC";
  return mime.split("/").pop().toUpperCase();
};
